import { z } from 'zod';
import { getChatSeedStrategy } from './registry';
import type { ChatSeedBuildInput } from './types';

const uuidSchema = z.string().uuid();

export type ResolvedChatSeedContext = {
  type: string;
  input: ChatSeedBuildInput;
};

export function resolveChatSeedContext(
  searchParams: URLSearchParams
): ResolvedChatSeedContext | null {
  const seed = searchParams.get('seed');
  if (seed === null) {
    return null;
  }

  const strategy = getChatSeedStrategy(seed);
  if (strategy === undefined) {
    return null;
  }

  const rawArtifactId = searchParams.get('artifactId');
  if (rawArtifactId === null) {
    return null;
  }

  const parsedArtifactId = uuidSchema.safeParse(rawArtifactId);
  if (!parsedArtifactId.success) {
    return null;
  }

  const folderId = searchParams.get('folderId');
  const parsedFolderId =
    folderId === null ? undefined : uuidSchema.safeParse(folderId);

  return {
    type: seed,
    input: {
      artifactId: parsedArtifactId.data,
      isNew: searchParams.get('new') === '1',
      ...(parsedFolderId !== undefined &&
        parsedFolderId.success && { folderId: parsedFolderId.data }),
    },
  };
}
